<template lang="pug">
div
  stock-take-desktop(:id="id" :clinic-slug="warehouseSlug" list-page="HQInventoryStockTake" summary-page="HQStockTakeSummary")
</template>

<script>
import StockTakeDesktop from '@/components/clinic/inventory/stocktake/StockTakeDesktop.vue'

export default {
  components: { StockTakeDesktop },
  props: ['id'],
  computed: {
    warehouseSlug () {
      return this.$route.query.warehouseSlug
    }
  }
}
</script>
